'use client';

import type { Cookie, CookieType } from '@/types/storage';
import type { CookieSetOptions } from 'universal-cookie';

// This is the only place we're going to import this.
// eslint-disable-next-line no-restricted-imports
import { useCookies as useLibCookies } from 'react-cookie';

export const useSetCookie = () => {
  const setCookie = useLibCookies<Cookie>([])[1];

  return <T extends Cookie>(
    cookie: T,
    value: CookieType[T],
    options?: CookieSetOptions,
  ) => setCookie(cookie, value, { path: '/', ...options });
};

export const useRemoveCookie = () => {
  const removeCookie = useLibCookies<Cookie>([])[2];

  return <T extends Cookie>(cookie: T, options?: CookieSetOptions) =>
    removeCookie(cookie, { path: '/', ...options });
};

export const useManageCookies = () =>
  [useSetCookie(), useRemoveCookie()] as const;

type UseCookies = {
  <T extends Cookie>(cookie: T): CookieType[T] | undefined;
  <T extends Cookie[]>(
    cookies: T,
  ): { [K in T[number]]: CookieType[K] | undefined };
};
export const useCookies: UseCookies = <T extends Cookie>(cookies: T | T[]) => {
  const isArray = Array.isArray(cookies);
  const cookieArray = isArray ? cookies : [cookies];

  const cookieValues = useLibCookies(cookieArray)[0];

  return isArray ? cookieValues : cookieValues[cookies];
};
